import React from 'react';
import '../styles/App.css';


/**
 * Class used to render the list of methods based on controller function selection
 *
 * @author Ethan Jones
 */
class MethodTable extends React.Component{

    state = {
        isSingleMethod: null
    }
    /**
     * Iterates through list of programming methods and inserts them into a table to be displayed
     * If only one method exists, it is selected
     * @returns {*}
     */
    renderMethodData(){
        if(this.props.methods.length === 1){
            if(!this.props.singleMethod){
                this.props.handleMethodClick(this.props.methods[0][0].description, 0, true)
            }
            return(
                this.props.methods && this.props.methods.map((data, index)=>
                    <tr key = {index}>
                        <td onClick={()=> this.props.handleMethodClick(data[0].description,index)}
                            className={"selectedRow"}>
                            {data[0].description}
                        </td>
                    </tr>
                )
            )
        }
        return(
            this.props.methods.map((data, index)=>
                <tr key = {index}>
                    <td id={"method"+index} onClick={()=> this.props.handleMethodClick(data[0].description,index, false)}
                        className={this.props.methodIndex === index ? "selectedRow" :""}>
                        {data[0].description}
                    </td>
                </tr>
            )
        )
    }

    componentDidMount() {
        this.handleSingleMethodClick().then()
    }

    async handleSingleMethodClick(){
        if(this.props.methods.length > 1)
            return

        let methodRow = document.getElementById("method0")
        if (null !== methodRow) {
            methodRow.click()
        }
    }


    /**
     * Main render method for method table class
     * @returns {*}
     */
    render(){

        if(this.state.isSingleMethod === null){
            this.handleSingleMethodClick().then()
        }
        return(

            <div>
                <label className={"MethodTableLabel"}>
                    Select Programming Type
                </label>
                <div className={"MethodTableContainer"}>
                    <table>
                        {this.renderMethodData()}
                    </table>
                </div>
            </div>

        )
    }
}

export default MethodTable;